import { Injectable } from '@angular/core';

import { environment as env } from '@env';
import { Category } from '@models/category.model';

@Injectable({ providedIn: 'root' })
export class CategoriesService {
  private menuItems: Category[] = [
    { nameKey: 'HOME', navigationPath: ['dashboard'] },
    { nameKey: 'PROFILE', navigationPath: ['profile'] },
    { nameKey: 'YOUR_POLICIES', navigationPath: ['policies'] },
    { nameKey: 'YOUR_ACCIDENTS', navigationPath: ['accidents'] },
    { nameKey: 'ASK_ASSISTANCE', navigationPath: ['assistance'] },
    { nameKey: 'GO_TO_WEBSITE', url: env.idea.app.websiteURL }
  ];

  constructor() {}

  /**
   * Get the list of menu items.
   * Note: it's a slice of the array.
   */
  async getListOfMenuItems(): Promise<Category[]> {
    return this.menuItems.slice();
  }
}
